/* eslint-disable no-unsafe-optional-chaining */
import React from 'react';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as UserActions from 'store/actions/user';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

ChartJS.defaults.color = '#1F2445';
ChartJS.defaults.font.family = 'Lato'

function SimpleVerticalBarGraphic({ mainContent }) {
  const isHoursType = mainContent?.customYLabelAfter === 'hs'
  const yMin = (mainContent?.yMin || Math.min(...mainContent?.contentFormatted?.map(el => el?.data)?.flat()?.map(el => el)))
  const yMax = (mainContent?.yMax || Math.max(...mainContent?.contentFormatted?.map(el => el?.data)?.flat()?.map(el => el)))
  const formattedYMin = yMin
  const formattedYMax = yMax - yMin < 2 ? yMax + 1 : yMax

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: !mainContent?.noLegend,
        position: 'bottom',
        align: 'end',
        labels: {
          boxHeight: 10,
          usePointStyle: true,
          pointStyle: 'circle',
          font: {
            weight: 700,
          }
        }
      },
      tooltip: {
        callbacks: {
          title() {
            return null
          },
          label(context) {
            let currentLabel = ''

            mainContent?.contentFormatted?.map(el => {
              if (el?.title === context?.dataset?.label) {
                currentLabel = el?.dataFormatted?.find(item => item?.index === context?.dataIndex)?.item
              } 
            })

            return currentLabel
          }
        }
      }
    },
    scales: {
      x: {
        title: {
          color: '#915'
        },
        ticks: {
          font: {
            weight: 'bold'
          } 
        },
        grid: {
          color: '#FFF',
          borderColor: '#FFF',
          tickColor: '#FFF'
        },
        border: {
          color: '#FFF',
        }
      },
      y: {
        suggestedMin: formattedYMin,
        suggestedMax: formattedYMax,
        title: {
          color: '#915'
        },
        ticks: {
          precision: 0,
          font: {
            weight: 'bold'
          },
          callback: (value, index, labels) => {
            const afterContent = mainContent?.customYLabelAfter || ''
            
            if (isHoursType && value >= 24) {
              return `${parseFloat((value - 24)?.toFixed(0))}${afterContent}`
            }
            
            if ((value - Math.floor(value)) !== 0){
              return '';
            }
            
            return `${parseFloat((value || 0)?.toFixed(0))}${afterContent}`;
          }
        },
        grid: {
          color: '#FFF',
          borderColor: '#FFF',
          tickColor: '#FFF'
        },
        border: {
          color: '#FFF',
        }
      }
    }
  };

  const labels = mainContent?.labels || [];
  
  const data = {
    labels,
    datasets: mainContent?.contentFormatted?.length ? 
      mainContent?.contentFormatted?.map(el => (
        {
          label: el?.title,
          data: el?.data,
          dataFormatted: el?.dataFormatted,
          borderColor: el?.color,
          backgroundColor: el?.color,
          borderRadius: 15,
          barThickness: 10,
        }
      )) 
    : [],
  };

  return (
    <Line options={options} data={data} />
  )
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(UserActions, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SimpleVerticalBarGraphic);
